// @config
import { xervixApi, xervixApiMultipart } from '../config/axios.config';

// @constants
import { API_ROUTES } from '../constants/apiRoutes';

// @types
import { CreatePostRequest, Post, PostResponse } from '../types/post.types';

const createPost = async (data: CreatePostRequest): Promise<Post> => {
  const response = await xervixApi.post(API_ROUTES.POST.CREATE_POST, data);
  return response.data;
};

const getPostsByProfessional = async (professionalId: string, isActive?: boolean): Promise<Post[]> => {
  try {
    const response = await xervixApi.get(
      API_ROUTES.POST.GET_BY_PROFESSIONAL(professionalId),
      {
        params: { isActive }
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

const getPostById = async (postId: string): Promise<Post> => {
  const response = await xervixApi.get(API_ROUTES.POST.GET_BY_ID(postId));
  return response.data;
};

const deletePost = async (postId: string): Promise<void> => {
  await xervixApi.delete(API_ROUTES.POST.DELETE_POST(postId));
};

const addImagePost = async (formData: FormData, id: string) => {
  try {
    const response = await xervixApiMultipart.post(API_ROUTES.POST.ADD_IMAGE_POST(id), formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
}

const getImageByPost = async (postId: string): Promise<any> => {
  try {
    const response = await xervixApi.get(API_ROUTES.POST.GET_IMAGE_POST(postId));
    return response;
  } catch (error) {
    throw error;
  }
}

const getPostForAllCompanies = async (): Promise<PostResponse> => {
  try {
    const response = await xervixApi.get(`${API_ROUTES.POST.GET_ALL_POST}?pageNumber=1&pageSize=1000`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

const methodsPost = {
  createPost,
  getPostsByProfessional,
  getPostById,
  deletePost,
  addImagePost,
  getImageByPost,
  getPostForAllCompanies
};

export default methodsPost;